export default __webpack_public_path__ + "static/media/brachiaria.1c6c7a72.png";